/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {CommonModule} from '@angular/common';
import {ClaimInformationFormComponent} from './claim-information-form.component';
import {NgModule} from '@angular/core';
import {LoadingSpinnerModule} from '../../../shared/loading/loading-spinner/loading-spinner.module';
import {ReactiveFormsModule} from '@angular/forms';
import {NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {InputModule} from '../../../shared/input/input.module';
import {WarningsModule} from '../../../shared/warnings/warnings.module';
import {DragAndDropModule} from '../../../shared/drag-and-drop/drag-and-drop.module';
import {UploadProgressModule} from '../../../shared/upload-progress/upload-progress.module';
import {FileListModule} from '../../../shared/file-list/file-list.module';
import {DragAndDropErrorModule} from '../../../shared/drag-and-drop-error/drag-and-drop-error.module';

@NgModule({
    declarations: [ClaimInformationFormComponent],
    imports: [
        CommonModule,
        LoadingSpinnerModule,
        ReactiveFormsModule,
        NgbTypeaheadModule,
        InputModule,
        WarningsModule,
        DragAndDropModule,
        UploadProgressModule,
        FileListModule,
        DragAndDropErrorModule

    ],
    exports: [ClaimInformationFormComponent]
})
export class ClaimInformationFormModule {
}
